import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const ProtectedRoute = ({ 
  requiredRole = null // Optional role requirement
}) => {
  const { isAuthenticated, isLoading, currentUser } = useContext(AuthContext);

  // If auth is still loading, show nothing
  if (isLoading) {
    return null;
  }
  
  // If user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // If role is required and user doesn't have the role, redirect to unauthorized
  if (requiredRole && currentUser.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  // Render the protected component
  return <Outlet />;
};

export default ProtectedRoute;